import { render, staticRenderFns } from "./cart_item.vue?vue&type=template&id=035508d6"
import script from "./cart_item.vue?vue&type=script&lang=js"
export * from "./cart_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035508d6')) {
      api.createRecord('035508d6', component.options)
    } else {
      api.reload('035508d6', component.options)
    }
    module.hot.accept("./cart_item.vue?vue&type=template&id=035508d6", function () {
      api.rerender('035508d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/cart_item.vue"
export default component.exports